import React, { useState } from 'react';

function Projects({ displayOption, title }) {
    // latest websites software 3dmodels graphicdesign ui/ux illustration
    const [projects] = useState([

        // ************************** workingon **************************  

        { id: 1, name: "Community forum", description: "now",
        category: "workingon", size:"", imageUrl: "./imgs/workingon/image01.png", projectUrl: "" },
        { id: 2, name: "Data encryptor", description: "now",
        category: "workingon", size:"", imageUrl: "./imgs/workingon/image02.png", projectUrl: "" },
        { id: 3, name: "Notes like Discord", description: "now",
        category: "workingon", size:"", imageUrl: "./imgs/workingon/image03.png", projectUrl: "" },

        // ************************** websites **************************  

        { id: 11, name: "Current web", description: "2024",
        category: "websites", size:"", imageUrl: "./imgs/websites/image01.png", projectUrl: "http://artbytefilip.eu" },
        { id: 6, name: "Music player", description: "2022",
        category: "websites", size:"", imageUrl: "./imgs/websites/image06.png", projectUrl: "./websites/music-player/" },
        { id: 8, name: "RDS", description: "2023",
        category: "websites", size:"", imageUrl: "./imgs/websites/image04.png", projectUrl: "./websites/rds-site/" },
        { id: 10, name: "Timer", description: "2023",
        category: "websites", size:"", imageUrl: "./imgs/websites/image02.png", projectUrl: "./websites/timer/" },
        { id: 4, name: "Portfolio", description: "2024",
        category: "websites", size:"", imageUrl: "./imgs/websites/image08.png", projectUrl: "./websites/filip-portfolio" },
        { id: 9, name: "Swap notes", description: "2023",
        category: "websites", size:"", imageUrl: "./imgs/websites/image03.png", projectUrl: "./websites/swap-notes/" },
        { id: 7, name: "Old ABF portoflio", description: "2021",
        category: "websites", size:"", imageUrl: "./imgs/websites/image05.png", projectUrl: "./websites/old-abf-portfolio" },
        { id: 5, name: "Music list", description: "2023",
        category: "websites", size:"", imageUrl: "./imgs/websites/image07.png", projectUrl: "./websites/music-list/" },
        { id: 3, name: "Dino runner", description: "2022",
        category: "websites", size:"", imageUrl: "./imgs/websites/image09.png", projectUrl: "./websites/dino-runner/" },
        { id: 2, name: "Card profil page", description: "2021",
        category: "websites", size:"", imageUrl: "./imgs/websites/image10.png", projectUrl: "./websites/card-profil-page/" },
        { id: 1, name: "ABF portfolio", description: "2022",
        category: "websites", size:"", imageUrl: "./imgs/websites/image11.png", projectUrl: "./websites/abf-portfolio/" },

        // ************************** software **************************  

        { id: 3, name: "More software?", description: "Try going to my github.",
        category: "software", size:"", imageUrl: "./imgs/software/image03.png", projectUrl: "https://github.com/ArtByteFilip" },
        { id: 1, name: "Turbo Text Renamer", description: "Program overwrites all files it finds in the location where it is running. It will change the text you select to another text of your choice. For example email.",
        category: "software", size:"", imageUrl: "./imgs/software/image01.png", projectUrl: "https://github.com/ArtByteFilip/turbo-text-renamer" },
        { id: 2, name: "Fishing plugin", description: "Plugin for minecraft that improves the ability to fishing.",
        category: "software", size:"", imageUrl: "./imgs/software/image02.png", projectUrl: "https://github.com/ArtByteFilip/minecraft-fishing-plugin" },

        // ************************** 3dmodels **************************  

        { id: 9, name: "Docks assets", description: "2024",
        category: "3dmodels", size:"long", imageUrl: "./imgs/3dmodels/image09.png", projectUrl: "#3dmodelsProjects" },
        { id: 8, name: "Torch stand", description: "2024",
        category: "3dmodels", size:"long", imageUrl: "./imgs/3dmodels/image08.png", projectUrl: "#3dmodelsProjects" },
        { id: 7, name: "Hat", description: "2023",
        category: "3dmodels", size:"long", imageUrl: "./imgs/3dmodels/image06.png", projectUrl: "#3dmodelsProjects" },
        { id: 10, name: "World assets", description: "2023",
        category: "3dmodels", size:"long", imageUrl: "./imgs/3dmodels/image10.png", projectUrl: "#3dmodelsProjects" },
        { id: 6, name: "Locker", description: "2023",
        category: "3dmodels", size:"long", imageUrl: "./imgs/3dmodels/image07.png", projectUrl: "#3dmodelsProjects" },
        { id: 5, name: "Chest", description: "2023",
        category: "3dmodels", size:"long", imageUrl: "./imgs/3dmodels/image05.png", projectUrl: "#3dmodelsProjects" },
        { id: 4, name: "Crossbow", description: "2023",
        category: "3dmodels", size:"long", imageUrl: "./imgs/3dmodels/image04.png", projectUrl: "#3dmodelsProjects" },
        { id: 3, name: "Barel", description: "2023",
        category: "3dmodels", size:"long", imageUrl: "./imgs/3dmodels/image03.png", projectUrl: "#3dmodelsProjects" },
        { id: 2, name: "Popcorn", description: "2023",
        category: "3dmodels", size:"long", imageUrl: "./imgs/3dmodels/image02.png", projectUrl: "#3dmodelsProjects" },
        { id: 1, name: "Park assets", description: "2023",
        category: "3dmodels", size:"long", imageUrl: "./imgs/3dmodels/image01.png", projectUrl: "#3dmodelsProjects" },

        // ************************** graphicdesign **************************  

        { id: 7, name: "GRA logo", description: "2024",
        category: "graphicdesign", size:"medium", imageUrl: "./imgs/graphicdesign/image07.jpg", projectUrl: "#graphicdesignProjects" },
        { id: 6, name: "RDS logo", description: "2024",
        category: "graphicdesign", size:"long", imageUrl: "./imgs/graphicdesign/image06.jpg", projectUrl: "#graphicdesignProjects" },
        { id: 5, name: "Vectors logo", description: "2024",
        category: "graphicdesign", size:"long", imageUrl: "./imgs/graphicdesign/image05.jpg", projectUrl: "#graphicdesignProjects" },
        { id: 8, name: "Frog logo", description: "2024",
        category: "graphicdesign", size:"medium", imageUrl: "./imgs/graphicdesign/image08.jpg", projectUrl: "#graphicdesignProjects" },
        { id: 1, name: "ArtByteFilip logo", description: "2023",
        category: "graphicdesign", size:"long", imageUrl: "./imgs/graphicdesign/image01.jpg", projectUrl: "#graphicdesignProjects" },
        { id: 4, name: "Code Conqueror logos", description: "2022",
        category: "graphicdesign", size:"medium", imageUrl: "./imgs/graphicdesign/image04.jpg", projectUrl: "#graphicdesignProjects" },
        { id: 3, name: "YouTube icon", description: "2022",
        category: "graphicdesign", size:"medium", imageUrl: "./imgs/graphicdesign/image03.jpg", projectUrl: "#graphicdesignProjects" },
        { id: 2, name: "Personal logo", description: "2021",
        category: "graphicdesign", size:"long", imageUrl: "./imgs/graphicdesign/image02.jpg", projectUrl: "#graphicdesignProjects" },

        // ************************** games **************************  

        { id: 1, name: "coming soon", description: "now",
            category: "games", size:"", imageUrl: "./imgs/games/image01.png", projectUrl: "" },

        // ************************** illustration **************************  

        { id: 9, name: "Vector", description: "Sketch from pinterest transformed into vector",
        category: "illustration", size:"long", imageUrl: "./imgs/illustration/image09.jpg", projectUrl: "#illustrationProjects" },
        { id: 8, name: "Vector", description: "Sketch from pinterest transformed into vector",
        category: "illustration", size:"long", imageUrl: "./imgs/illustration/image08.jpg", projectUrl: "#illustrationProjects" },
        { id: 7, name: "Vector", description: "Sketch from pinterest transformed into vector",
        category: "illustration", size:"long", imageUrl: "./imgs/illustration/image07.jpg", projectUrl: "#illustrationProjects" },
        { id: 6, name: "Vector", description: "Sketch from pinterest transformed into vector",
        category: "illustration", size:"long", imageUrl: "./imgs/illustration/image06.jpg", projectUrl: "#illustrationProjects" },
        { id: 5, name: "Vector", description: "Sketch from pinterest transformed into vector",
        category: "illustration", size:"long", imageUrl: "./imgs/illustration/image05.jpg", projectUrl: "#illustrationProjects" },
        { id: 4, name: "Vector", description: "Sketch from pinterest transformed into vector",
        category: "illustration", size:"long", imageUrl: "./imgs/illustration/image04.jpg", projectUrl: "#illustrationProjects" },
        { id: 3, name: "Vector", description: "Sketch from pinterest transformed into vector",
        category: "illustration", size:"long", imageUrl: "./imgs/illustration/image03.jpg", projectUrl: "#illustrationProjects" },
        { id: 2, name: "Vector", description: "2021",
        category: "illustration", size:"long", imageUrl: "./imgs/illustration/image02.jpg", projectUrl: "#illustrationProjects" },
        { id: 1, name: "Vector", description: "2021",
        category: "illustration", size:"long", imageUrl: "./imgs/illustration/image01.jpg", projectUrl: "#illustrationProjects" },
    ]);
    const [displayedProjects, setDisplayedProjects] = useState(3);

    const [selectedCategory] = useState(displayOption);
    const filteredProjects = selectedCategory === 'all' ? projects : projects.filter(project => project.category === selectedCategory);
    const visibleProjects = filteredProjects.slice(0, displayedProjects);

    const handleSeeMoreClick = () => {
        setDisplayedProjects(prevCount => prevCount + 3);
    };

    let formatedTitle = title && title.replace(/\s+/g, '').toLowerCase();
    let hrTitle = title.length * 10;

    return (
        <>
            <div id={`${formatedTitle}Projects`} className="shortProjects">
                <div className="container max-w-screen-sm mx-auto py-8 px-4 flex flex-col justify-center items-center">
                    <h2 className="font-bold text-red-500 uppercase">projects</h2>
                    <h1 className="font-bold text-2xl text-center">{title}</h1>
                    <hr style={{ width: hrTitle }} className="border-b-2 my-3 text-center" />

                    {visibleProjects.map(project => (
                        <ul className="flex flex-col w-full">
                            <a href={project.projectUrl}>
                                <li
                                    key={project.id}
                                    style={{
                                        backgroundImage: `url(${project.imageUrl})`,
                                        height: project.size === "medium" ? "20rem" : project.size === "long" ? "35rem" : "10rem"
                                    }}
                                    className="border-b-4 border-solid border-transparent hover:border-red-500 bg-gray-200 rounded-lg w-full p-4 mb-4 flex flex-col justify-end bg-cover bg-no-repeat bg-center"
                                >
                                    <h1 className="font-bold text-xl rounded bg-white bg-opacity-70 w-fit p-2 py-1 mb-1 ml-1">{project.name}</h1>
                                    <p className="text-base rounded bg-white opacity-70 w-fit p-2 py-1  ml-1">{project.description}</p>
                                </li>


                            </a>
                        </ul>
                    ))}

                    {visibleProjects.length < filteredProjects.length && (
                        <button onClick={handleSeeMoreClick} className="py-3 px-5 mt-4 bg-red-500 hover:bg-red-600 font-bold uppercase rounded-lg text-white">see more</button>
                    )}
                </div>
            </div>
        </>
    );
}

export default Projects;